import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Guid } from "guid-typescript";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { DocumentBlob } from "../models/document-blob";
import { convertBase64ToBlob } from "../../shared/helpers/file.helper";

@Injectable({
  providedIn: "root",
})
export class DocumentService {
  private documentUrl = "documents";
  constructor(private http: HttpClient) {}

  getAgreementDocument(id: Guid): Observable<DocumentBlob> {
    return this.http.get<DocumentBlob>(environment.apiConfig.uri + this.documentUrl + "/" + id + "/content");
  }

  onDownload(id: Guid) {
    this.getAgreementDocument(id).subscribe(data => {
      const blob = convertBase64ToBlob(atob(data.fileContents));
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = data.fileDownloadName;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }
  onView(id: Guid) {
    this.getAgreementDocument(id).subscribe(data => {
      const blob = convertBase64ToBlob(atob(data.fileContents), data.fileDownloadName.split(".")[1]);
      const url = URL.createObjectURL(blob);
      window.open(url);
    });
  }
}
